import React, { Component } from "react";
import "../../../styles/pages/projects/ProjectImage.css";

export default class ProjectImage extends Component {
  render() {
    var renderImages = this.getLayoutMarkup();
    return (
      <div
        className={`ProjectImage ${this.props.layout}`}
        style={{ background: this.props.backgroundColor }}
      >
        {renderImages}
      </div>
    );
  }

  // Returns the markup for different layouts
  getLayoutMarkup() {
    var layout = this.props.layout;

    if (layout === "big-image") {
      return (
        <div className="image-container gutters">
          <img
            className="on-scroll-anim"
            src={this.props.image}
            alt={this.props.projectName}
          />
        </div>
      );
    } else if (layout === "gif-showcase") {
      return (
        <div className="image-container gutters">
          <img
            className="mobile on-scroll-anim"
            src={this.props.mobileImages[0]}
            alt={this.props.projectName}
          />
          <img
            className="mobile on-scroll-anim"
            src={this.props.mobileImages[1]}
            alt={this.props.projectName}
          />
          <img
            className="gif on-scroll-anim"
            src={this.props.gif}
            alt={this.props.projectName}
          />
        </div>
      );
    } else if (layout === "two-big") {
      return (
        <div className="image-container gutters">
          <img
            className="on-scroll-anim"
            src={this.props.images[0]}
            alt={this.props.projectName}
          />
          <img
            className="on-scroll-anim"
            src={this.props.images[1]}
            alt={this.props.projectName}
          />
        </div>
      );
    }
  }
}
